module.exports = __webpack_public_path__ + "static/media/short_notes.6c22851a.png";